<template lang="pug">
	.conflict-detection-tool-view-tag(v-if="showed")
		.modal(:tabindex="-1" :role="'dialog'" :style="{'display': 'block'}")
			.modal-dialog.modal-dialog-centered(:role ="'document'")
				.modal-content
					.modal-header
						h5.modal-title Conflict detection tool tag
					.modal-body
						.modal-loaded
							.form-group
								textarea.form-control(:rows="9" wrap="off" v-model="cdttag" )
					.modal-footer
						button.btn.btn-primary(type="button" v-on:click="copy")
							i.fa.fa-copy
							| &nbsp;&nbsp;Copy
						button.btn.btn-dark(type="button" v-on:click="close") Close

</template>
<script>
	import Screen 				from './../../mixins/screen';
	import {Layout} from "@/services/Layout";
	import SetupSettings 					from "./../../settings/settings.json";

	export default {
		name: 'SettingsConflictDetectionToolViewTag',
		mixins: [Screen],
		screen: {
			events: {},
			updateOn: [],
			showed: false,
			received: false
		},
		data() {
			return {
				cdttag: ''
			}
		},
		methods: {
			collectData() {
				let scriptName = SetupSettings.dev ? 'prvk-conflict-detection-tool-dev.js' : 'prvk-conflict-detection-tool.min.js';
				this.cdttag =
`<script>
	const cdtScript = document.createElement("script");
	cdtScript.type = "text/javascript";
	cdtScript.src = "https://cdn.prvk.io/prvk-conflict-detection-tool/${scriptName}?v=%%CACHEBUSTER%%";
	cdtScript.async = true;
	cdtScript.dataset.cfasync = false;
	window.top.document.body.appendChild(cdtScript);
<\/script>`;

			},
			close() {
				this.hide();
			},
			copy() {
				let text = this.cdttag;

				Layout.copyTextToClipboard(text);
			}
		}

	}
</script>
<style lang="sass">

	.conflict-detection-tool-view-tag
		position: absolute
		z-index: 2000
		left: 0
		top: 0
		right: 0
		bottom: 0
		background-color: rgba(0, 0, 0, 0.6)

		.modal-content
			border: none
			background: none

			.modal-header
				background-color: #343b41
				border-bottom: 1px solid #23282c
				color: #e4e7ea

			.modal-body
				background-color: #3a4149

				.modal-loaded

					textarea
						font-size: 12px
						background: transparent
						color: #c8ced3
						border-color: transparent

			.modal-footer
				background-color: #3a4149
				border: none
				justify-content: space-between


</style>
